import React, {PureComponent, createRef} from 'react';
import katex from 'katex';

import Button from '@material-ui/core/Button';
import Slider from '@material-ui/core/Slider';

import {
    initialize, step, reset,
    cleanUp,
    getValue, getMetadata,
    setKernelSize,
} from './render.js';
import './index.css';

class PiComputer extends PureComponent {
    state = {
        estimate: 0,
        width: 0,
        height: 0,
        N: 0,
        quality: 0,
    };

    componentDidMount() {
        initialize(this.canvas.current);
        this.updateValue();
        this.updateMetadata();

        this.resizeListener = this.updateMetadata.bind(this);
        window.addEventListener('resize', this.resizeListener);
    }

    updateValue() {
        const estimate = getValue();
        this.setState({estimate}); 
        katex.render(`\\pi \\approx ${estimate.toFixed(5)}...`, this.estimate.current);
    }

    updateMetadata() {
        const [width, height, N, quality] = getMetadata();
        this.setState({width, height, N, quality}); 
        katex.render(`N = ${N}`, this.sparsityLabel.current);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeListener);
        cleanUp();
    }

    render() {
        const {width, height, N, quality} = this.state;

        this.canvas = createRef();
        this.estimate = createRef();
        this.sparsityLabel = createRef();

        return <div className='pi-computer'>
            <p className='estimate' ref={this.estimate}></p>
            <div className='controls'>
                <Button
                    onClick={() => {step(); this.updateValue();}}
                    variant='contained'
                    color='primary'
                >Step</Button>
                <Button
                    onClick={reset}
                    variant='outlined'
                >Reset</Button>
            </div>
            <canvas ref={this.canvas}>Please enable Javascript and WebGL to use the demo.</canvas>
            <div className='kernel-slider'>
                <p className='header'>Kernel Sparsity</p>
                <p className='label' ref={this.sparsityLabel}/>
                <Slider
                    min={3} max={100}
                    value={N}
                    onChange={(e, v) => {setKernelSize(v); this.updateMetadata();}}
                />
            </div>
            <p className='size'>
                Texture Size: {width} × {height}<br/>
                Estimated Quality: Q(K) = {quality.toFixed(3)}<br/>
            </p>
        </div>
    }
}

export default PiComputer;
